import {
  AfterContentInit,
  Component, ElementRef,
  Injector,
  Optional, ViewChild
} from '@angular/core';
import {CommonModule} from "@angular/common";

import {
  DISPLAY_TYPE,
  IWidgetConfig,
  StylableComponent,
  provideAsWidgetRef,
  Parent,
  register,
  styler,
  APPLY_STYLES_TYPE
} from "@wm/components-base";
import {WmsTranscludeDirective} from "../../page/wms-transclude/wms-transclude.directive";

const DEFAULT_CLS = 'app-panel panel';
const WIDGET_CONFIG: IWidgetConfig = {
  widgetType: 'wm-panel',
  hostClass: DEFAULT_CLS,
  displayType: DISPLAY_TYPE.INLINE_BLOCK
};

@Component({
  selector: '[wmPanel]',
  template: `
    <div class="panel-heading {{helpClass}}" aria-label="Panel header" *ngIf="showHeader" #panelHeading>
      <h3 class="panel-title">
        <a class="panel-toggle" (click)="toggle()">
          <div class="pull-left">
            <i class="app-icon panel-icon {{iconclass}}" *ngIf="iconclass && !iconurl"></i>
            <!--           TODO: use image pipe-->
            <img data-identifier="img" title="iconurl" alt="Panel icon" class="panel-image-icon"
                 [src]="iconurl" *ngIf="iconurl"
                 [ngStyle]="{width: iconwidth ,height: iconheight, margin: iconmargin}" />
          </div>
          <div class="pull-left">
            <div class="heading" [innerHTML]="title" [title]="title"></div>
            <div class="description" [innerHTML]="subheading"></div>
          </div>
        </a>
        <div class="panel-actions">
                      <span *ngIf="badgevalue" aria-label="badge"
                            class="app-badge label label-{{badgetype}}">{{badgevalue}}</span>
          <div wmMenu aria-label="dropdown" dropdown type="anchor" class="panel-action" dataset.bind="actions"
               *ngIf="actions" caption="" menuposition="down,left" iconclass="wi wi-more-vert"
               autoclose.bind="autoclose" datafield.bind="datafield" select.event="menuActionItemClick($event,$item)">
          </div>
          <button type="button" aria-label="Help" class="app-icon panel-action wi" [title]="appLocale.LABEL_HELP"
                  *ngIf="helptext"><i class="wi-question"></i></button>
          <button type="button" aria-label="Collapse/Expand" class="app-icon wi panel-action" *ngIf="collapsible"
                  [title]="expandCollapseTitle" ><i
            [ngClass]="expanded ? 'wi wi-minus' : 'wi wi-plus'"></i></button>
          <button type="button" aria-label="Fullscreen/Exit" class="app-icon panel-action wi" *ngIf="enablefullscreen"
                  [title]="fullScreenTitle" ><i
            [ngClass]="fullscreen ? 'wi wi-fullscreen-exit' : 'wi wi-fullscreen'"></i></button>
          <button type="button" aria-label="Close button" class="app-icon panel-action"
                  *ngIf="closable" ><i
            class="wi wi-close"></i></button>
        </div>
      </h3>
    </div>
    <div class="panel-content" aria-label="Panel body" [hidden]="!expanded" #panelContent>
      <div page-container-target #panelBody [ngClass]="['panel-body', helpClass]" wmsTransclude>
        <ng-content></ng-content>
      </div>
      <aside class="panel-help-message" [ngClass]="helpClass">
        <h5 class="panel-help-header" ></h5>
        <div class="panel-help-content" [innerHTML]="helptext"></div>
      </aside>
    </div>
    <div class="app-panel-footer panel-footer clearfix" aria-label="Panel footer" [hidden]="hideFooter">
      <ng-content select="[wmPanelFooter]"></ng-content>
    </div>
  `,
  providers: [
    provideAsWidgetRef(PanelComponent)
  ],
  exportAs: 'wmPanel',
  standalone: true,
  imports: [CommonModule, WmsTranscludeDirective],
  styles: []
})
export class PanelComponent extends StylableComponent implements AfterContentInit{
  static initializeProps = register('wm-panel');

  public iconurl: string;
  public iconclass: string;
  public collapsible: boolean;
  public expanded = true;
  public enablefullscreen: boolean;
  public fullscreen: boolean;
  public title: string;
  public subheading: string;
  public actions: any;
  public selectedAction: string;

  public helpClass = '';
  public helptext = '';
  public headerbool: boolean;
  public fullScreenTitle: string;
  public expandCollapseTitle: string;
  public iconwidth: any;
  public iconheight: any;
  public iconmargin: any;
  public badgevalue: any;
  public badgetype: any;
  public closable: boolean;

  @ViewChild('panelBody',{static: true}) private panelBody: ElementRef;

  public hasFooter: boolean;
  constructor(inj: Injector,
              @Optional() viewParent: Parent) {
    super(inj, WIDGET_CONFIG, viewParent);
    styler(this.nativeElement, this);
  }

  get showHeader(){
    return this.iconurl || this.iconclass || this.collapsible || this.actions || this.title || this.subheading || this.enablefullscreen;
  }

  get hideFooter(){
    return !this.hasFooter || !this.expanded;
  }

  protected override onPropertyChange(key: string, nv: any, ov?: any) {
    if (key === 'expanded') {
      this.expanded = nv;
    } else {
      super.onPropertyChange(key, nv, ov);
    }
  }

  ngAfterContentInit() {
    this.hasFooter = !!this.nativeElement.querySelector('[wmPanelFooter]');
    styler(this.panelBody.nativeElement as HTMLElement, this, APPLY_STYLES_TYPE.INNER_SHELL);
  }

  toggle() {
    if (this.collapsible) {
      this.expanded = !this.expanded;
    }
  }
}

